<h1 mat-dialog-title>
    <span [translate]="'dashboard.listeInfos.detail.title'"></span>
    <span mat-dialog-close><i class="zmdi zmdi-close"></i></span>
</h1>
<div mat-dialog-content>
    <div class="alert" [ngClass]="{ 'alert-info': data.type == typeMessage.INFORMATION, 'alert-success': data.type == typeMessage.CONFIRMATION, 'alert-warning': data.type == typeMessage.AVERTISSEMENT, 'alert-danger': data.type == typeMessage.ALERTE }">
        <h4 class="alert-heading">{{ data.objet }}</h4>
        <p>{{ data.message }}</p>
    </div>
</div>